import React from "react";
import { Link } from "react-router-dom";

import heroImage from "../images/image/person.png";
import whiteRunner from "../images/image/PAREAGON 107.jpg";
import burgundyRunner from "../images/image/PAREAGON 86.jpg";
import whiteBlackRunner from "../images/image/PAREAGON 97.jpg";
import blackRunner from "../images/image/PARAEGON 42.jpg";

import lookbookOne from "../images/image/Black.jpg";
import lookbookTwo from "../images/image/Black2.jpg";
import lookbookThree from "../images/image/Burgundy.jpg";
import lookbookFour from "../images/image/Burgundy2.jpg";
import lookbookFive from "../images/image/Burgundy3.jpg";
import lookbookSix from "../images/image/Burgundy4.jpg";

const latestDrops = [
  {
    id: "gray",
    number: "No. I",
    name: "WHITE",
    description: "Runner · sculpted tonal finish",
    price: "$1,050 USD",
    image: whiteRunner,
  },
  {
    id: "yellow",
    number: "No. II",
    name: "BURGUNDY",
    description: "Runner · deep wine finish",
    price: "$1,050 USD",
    image: burgundyRunner,
  },
  {
    id: "topwhite",
    number: "No. III",
    name: "WHITE / BLACK",
    description: "Runner · high-contrast finish",
    price: "$1,050 USD",
    image: whiteBlackRunner,
  },
  {
    id: "black",
    number: "No. IV",
    name: "BLACK",
    description: "Runner · full monochrome finish",
    price: "$1,050 USD",
    image: blackRunner,
  },
];

const highlights = [
  "Limited pairs",
  "PARAEGON Runners",
  "Limited pairs",
  "Designed in Los Angeles",
  "PARAEGON Runners",
];

const lookbook = [
  lookbookOne,
  lookbookTwo,
  lookbookThree,
  lookbookFour,
  lookbookFive,
  lookbookSix,
];

const HomePage = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  };

  const scrollToCollection = () => {
    document.getElementById("collection")?.scrollIntoView({
      behavior: "smooth",
    });
  };

  return (
    <main className="bg-[#f4f1eb] text-[#171713]">
      {/* HERO SECTION */}
      <section className="relative min-h-[78vh] overflow-hidden bg-black text-white md:min-h-[88vh]">
        <img
          src={heroImage}
          alt="PΛREΛGON footwear campaign"
          className="absolute inset-0 h-full w-full object-cover object-center opacity-75 md:object-[center_62%]"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/30 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />

        <div className="relative mx-auto flex min-h-[78vh] max-w-7xl items-end px-6 pb-16 pt-28 md:min-h-[88vh] md:px-10 md:pb-24 lg:px-16">
          <div className="max-w-3xl">
            <p className="mb-5 text-xs uppercase tracking-[0.38em] text-white/75">
              Now dropping — the runner collection
            </p>

            <div className="mb-7 h-px w-24 bg-white/70" />

            <h1 className="font-serif text-5xl font-normal leading-[0.95] tracking-tight sm:text-6xl md:text-8xl">
              Dressed for the <span className="italic">arrival</span>.
            </h1>

            <p className="mt-7 max-w-xl text-sm font-light leading-7 text-white/80 md:text-base">
              PΛREΛGON creates statement runners with sculpted uppers and a bold,
              moulded sole—built to be noticed the moment you step out.
            </p>

            <div className="mt-9 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={scrollToCollection}
                className="border border-white bg-white px-7 py-3 text-xs font-medium uppercase tracking-[0.22em] text-black transition hover:bg-transparent hover:text-white"
              >
                Shop the collection
              </button>

              <a
                href="https://www.instagram.com/pareagonlife/"
                target="_blank"
                rel="noreferrer"
                className="border border-white/60 px-7 py-3 text-xs font-medium uppercase tracking-[0.22em] text-white transition hover:border-white hover:bg-white hover:text-black"
              >
                View lookbook
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* PRODUCT COLLECTION */}
      <section
        id="collection"
        className="mx-auto max-w-7xl px-6 py-20 md:px-10 md:py-28 lg:px-16"
      >
        <div className="mb-12 grid gap-8 border-b border-black/20 pb-10 md:grid-cols-[1.3fr_0.7fr] md:items-end">
          <div>
            <p className="text-xs uppercase tracking-[0.34em] text-black/55">
              The collection — four colourways
            </p>

            <h2 className="mt-4 font-serif text-4xl font-normal md:text-6xl">
              Four ways to wear it.
            </h2>
          </div>

          <p className="max-w-md text-sm font-light leading-7 text-black/65 md:justify-self-end">
            One Burgundy, four finishes—from clean tonal white to full black.
            Each release is produced in limited quantities.
          </p>
        </div>

        <div className="grid gap-x-5 gap-y-14 sm:grid-cols-2 lg:grid-cols-4">
          {latestDrops.map((drop) => (
            <Link
              key={drop.id}
              to={`/product/${drop.id}`}
              onClick={scrollToTop}
              className="group block"
            >
              <article>
                <div className="relative aspect-[4/5] overflow-hidden bg-[#e7e2d9]">
                  <span className="absolute left-4 top-4 z-10 text-[10px] uppercase tracking-[0.28em] text-black/55">
                    {drop.number}
                  </span>

                  <span className="absolute bottom-2 right-3 select-none font-serif text-7xl text-black/[0.05]">
                    {drop.number.replace("No. ", "")}
                  </span>

                  <img
                    src={drop.image}
                    alt={`PΛREΛGON ${drop.name} runner`}
                    loading="lazy"
                    className="h-full w-full object-cover transition duration-700 ease-out group-hover:scale-105"
                  />

                  <div className="absolute inset-x-0 bottom-0 translate-y-full bg-black px-5 py-4 text-center text-[10px] uppercase tracking-[0.25em] text-white transition duration-300 group-hover:translate-y-0">
                    View product
                  </div>
                </div>

                <div className="flex items-start justify-between gap-4 border-b border-black/20 py-5">
                  <div>
                    <h3 className="font-serif text-2xl">{drop.name}</h3>

                    <p className="mt-1 text-[11px] uppercase tracking-[0.18em] text-black/50">
                      {drop.description}
                    </p>
                  </div>

                  <p className="pt-1 text-xs font-medium">{drop.price}</p>
                </div>
              </article>
            </Link>
          ))}
        </div>
      </section>

      {/* PROMOTIONAL CAROUSEL */}
      <section className="overflow-hidden border-y border-[#8e6d36]/35 bg-[#15120e] py-5 text-[#d9c7a6]">
        <div className="pareagon-marquee flex w-max items-center">
          {[...highlights, ...highlights].map((item, index) => (
            <React.Fragment key={`${item}-${index}`}>
              <span className="px-10 font-serif text-lg italic tracking-wide md:px-16 md:text-xl">
                {item}
              </span>

              <span className="text-[8px] text-[#d2a85f]">◆</span>
            </React.Fragment>
          ))}
        </div>
      </section>

      {/* INSTAGRAM GRID */}
      <section className="bg-[#120f0b] px-6 py-20 text-[#eee7dc] md:px-10 md:py-28 lg:px-16">
        <div className="mx-auto max-w-[1440px]">
          <div className="mb-14 flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="text-xs uppercase tracking-[0.34em] text-[#d3a95e]">
                On Instagram
              </p>

              <h2 className="mt-3 font-serif text-4xl md:text-6xl">
                Out in PΛREΛGON.
              </h2>
            </div>

            <a
              href="https://www.instagram.com/pareagonlife/"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center rounded-full border border-[#8e6d36]/45 px-8 py-4 text-[11px] uppercase tracking-[0.25em] transition hover:border-[#d3a95e] hover:text-[#d3a95e]"
            >
               &nbsp; @pareagonlife
            </a>
          </div>

          <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:gap-4">
            {lookbook.map((image, index) => (
              <a
                key={image}
                href="https://www.instagram.com/pareagonlife/"
                target="_blank"
                rel="noreferrer"
                className="insta-post"
                aria-label={`Open PΛREΛGON Instagram look ${index + 1}`}
              >
                <img
                  src={image}
                  alt={`PΛREΛGON Instagram post ${index + 1}`}
                  loading="lazy"
                />

                <span className="insta-overlay" aria-hidden="true">
                  <span>
                    <svg viewBox="0 0 24 24" role="img">
                      <path d="M12 21.35 10.55 20.03C5.4 15.36 2 12.27 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09A6.02 6.02 0 0 1 16.5 3C19.58 3 22 5.42 22 8.5c0 3.77-3.4 6.86-8.55 11.54L12 21.35Z" />
                    </svg>

                    {index % 2 === 0 ? "10K" : "9.5K"}
                  </span>

                  <span>
                    <svg viewBox="0 0 24 24" role="img">
                      <path d="M21 6.5A3.5 3.5 0 0 0 17.5 3h-11A3.5 3.5 0 0 0 3 6.5v7A3.5 3.5 0 0 0 6.5 17H8l4 4 4-4h1.5a3.5 3.5 0 0 0 3.5-3.5v-7Zm-2 7a1.5 1.5 0 0 1-1.5 1.5h-2.33L12 18.17 8.83 15H6.5A1.5 1.5 0 0 1 5 13.5v-7A1.5 1.5 0 0 1 6.5 5h11A1.5 1.5 0 0 1 19 6.5v7Z" />
                    </svg>

                    {index % 3 === 0 ? "12" : "8"}
                  </span>
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .insta-post {
          position: relative;
          display: block;
          aspect-ratio: 4 / 5;
          overflow: hidden;
          background: #0e0c0a;
        }

        .insta-post img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.7s cubic-bezier(0.2, 0.7, 0.2, 1);
        }

        .insta-post:hover img,
        .insta-post:focus-visible img {
          transform: scale(1.07);
        }

        .insta-overlay {
          position: absolute;
          inset: 0;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1.3rem;
          background: rgba(14, 12, 10, 0.55);
          backdrop-filter: blur(1px);
          -webkit-backdrop-filter: blur(1px);
          opacity: 0;
          transition: opacity 0.35s ease;
          font-size: 0.8rem;
          letter-spacing: 0.06em;
          color: #eee7dc;
        }

        .insta-post:hover .insta-overlay,
        .insta-post:focus-within .insta-overlay {
          opacity: 1;
        }

        .insta-overlay span {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
        }

        .insta-overlay svg {
          width: 15px;
          height: 15px;
          fill: #eee7dc;
        }

        @keyframes pareagonMarquee {
          from {
            transform: translateX(0);
          }

          to {
            transform: translateX(-50%);
          }
        }

        .pareagon-marquee {
          animation: pareagonMarquee 28s linear infinite;
        }

        .pareagon-marquee:hover {
          animation-play-state: paused;
        }

        @media (prefers-reduced-motion: reduce) {
          .pareagon-marquee {
            animation: none;
          }

          .insta-post img,
          .insta-overlay {
            transition: none;
          }
        }
      `}</style>
    </main>
  );
};

export default HomePage;